import { useSelector } from 'react-redux';

export const useShowInternationalOptions = () =>
    useSelector(
        (state) =>
            state.user?.activeBusiness?.businessSettings
                ?.showInternationalOptions || false
    );
